import React, { Fragment } from "react"
import './announcement.scss'

import { Link } from 'react-router-dom'

import Navbar from '../../components/newNavbar/navbar'
// import Button from '../../components/newButton/newButton'
// import ButtonText from '../../components/buttonText/buttonText'
import Loading from '../../components/loading/loading'
// import CardFeatured from '../../components/cardFeatured/cardFeatured'
import CardFeaturedPro from '../../components/cardFeaturedPro/cardFeaturedPro'
// import CardFeaturedBasic from '../../components/cardFeaturedBasic/cardFeaturedBasic'
import ChipWord from '../../components/chipWord/chipWord'
import IconCtg from '../../components/iconCtg/iconCtg'
import { Query } from "react-apollo"
import { Categories } from '../../queries/category'
import Input from '../../components/newInput/input'
import { GraphQLClient } from 'graphql-request'
import { Destaques } from '../../queries/anuncios'
import { endpoint } from '../../queries/endpoint'
import ErrorM from '../../components/ErrorMessange/errormenssage'
import Footer from '../../components/newFooter/footer'
// import { toast } from 'react-toastify';
import ErrorBroundray from '../../components/errorBoundary/errorBoundary'

export default class Announcement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      service: [],
      filtered: false,
      listfilter: [],
      searchResult: null
    }
  }

  finder = (query) => {
    // console.log(query)
    this.setState({ searchResult: null })
    if (query !== undefined && query.length > 2) {
      const client = new GraphQLClient(endpoint)

      client.request(`
            {
                allUsers(
                  filter: {
                    OR: [
                      {
                        address: {
                        city_contains: "${query}"
                      }
                      },
                      {
                        name_contains: "${query}"
                      },
                      {
                        anuncioses_some: {
                          OR: [
                            {
                              description_contains: "${query}"
                            },
                            {
                              skills: {
                          name_contains: "${query}"
                        }
                            }
                          ],
                          AND: [
                            {
                              active: true
                            }
                          ]
                      }
                      }      
                    ],
                    AND: [
                      {
                        type: PROFISSIONAL
                      },
                      {
                        status: true
                      },
                      {
                        anuncioses_some: {
                          active: true
                        }
                      }
                    ]
                  }
                )
                {
                  name
                  type
                  photo
                  id
                  address {
                    city
                    state
                  }
                  ranks {
                    typeTo
                    media
                  }
                  anuncios {
                    active
                    description
                    skill {
                      name
                    }
                  }
                }
              }
            `).then(
        res => {
          this.setState({ listfilter: res.allUsers })
          if (res.allUsers.length < 1) {
            this.setState({ searchResult: <ErrorM content='Não foi encontrado nenhum anúncio ou profissional.' /> })
          }
        }
      )
    } else if (query === '' || query.length <= 2) {
      this.setState({ listfilter: [] })
      // if (this.state.listfilter.length > 0) {
      //   this.setState({ listfilter: [] })
      // }
    }
  }

  render() {
    return (
      <Fragment>

        <div className={'Announcement col-xs-12'}>
          {this.state.loading ? <Loading /> : null}
          <div className="row center-xs">
            <div className="col-xs-12" style={{ maxWidth: '600px' }}>
              <ErrorBroundray><Input placeholder={'Pesquisar...'} name={'search'} onInput={e => this.finder(e.target.value)} /></ErrorBroundray>
              {this.state.searchResult}
            </div>
          </div>

          <div className="row">
            {this.state.listfilter.length > 0 ?
              <div className={'serviceCards col-xs-12'}>
                <div className="row">
                  {this.state.listfilter.map((player, i) => {
                    let count = 0
                    player.ranks.map(med => (
                      med.typeTo === "PROFISSIONAL" ?
                        count = count + med.media : null
                    ))
                    player.total = (count / (player.ranks.length))
                    return <ErrorBroundray key={i}><CardFeaturedPro name={player.name} avaliationStar={player.total} mainJob={player.anuncioses} photo={player.photo ? player.photo.url : player.avatar ? player.avatar : null} link={player.id} /></ErrorBroundray>
                  })}
                </div>
              </div>
              : <>
                <div className="col-xs-12">
                  <h1>Categoria</h1>
                </div>
                <div className={'sideSlide col-xs-12 center-xs'}>
                  <Query query={Categories}>
                    {result => {
                      if (result.loading) return <Loading />
                      if (result.error) return <p>{result.error.message}</p>
                      return (
                        result.data.allCategories.length ?
                          result.data.allCategories.map((p, i) => {
                            // console.log(p);
                            return <div key={i} className="catdrop">
                              <IconCtg icon={p.file} label={true} name={p.name} onClick={() => this.setState({ service: p.skills })} />
                              <div className="arrow" />
                              <div className={'filterList'}>   {/*  fazer aqui como uma drop, tipo getninjas */}
                                <h4>{p.name}</h4>
                                <ol>
                                  {p.skills.length > 0 ?
                                    // this.state.service.map((hab, i) => <ChipWord key={i} name={hab.name} onClick={() => window.location.href = "/anuncios/" + hab.name.replace('/', '+')} />)
                                    p.skills.map((hab, i) => <ErrorBroundray key={i}><li onClick={() => window.location.href = "/anuncios/" + hab.id}><ChipWord name={hab.name} /></li></ErrorBroundray>)
                                    : null}
                                </ol>
                              </div>
                            </div>
                          }
                          ) :
                          <article className="msg-not-found"><h5>Infelizmente não encontramos nenhum profissional. <Link to="/cadastro">Cadastre-se</Link> para ser o primeiro!</h5></article>
                      )
                    }}
                  </Query>
                </div>

                <div className="destaque">
                  <div className="col-xs-12">
                    <h1>Destaques</h1>
                  </div>
                  <div className={'listDest col-xs-12'}>
                    <Query query={Destaques}>
                      {res => {
                        if (res.loading) return <Loading />
                        // if (res.error) {
                        //   window.setTimeout(window.location.reload(), 3000)
                        //   console.log(res.error)
                        //   return <p>Algum erro aconteceu. Tente novamente.</p>
                        // }

                        console.log(res.data)
                        let dest = []

                        if (res.data && res.data.allUsers) {
                          // res.data.allUsers.map(player => (
                          //   player.ranks.length > 0 && player.anuncioses.length > 0 ?
                          //     dest.push(player)
                          //     : null
                          res.data.allUsers.map(player => (
                            player.ranks.length > 0 && player.anuncioses.length > 0 ?
                              dest.push(player)
                              : null
                          ))

                          dest.map(player => {
                            let count = 0
                            player.ranks.map(med => (
                              count = count + med.media
                            ))
                            player.total = (count / (player.ranks.length))
                            return null
                          })

                          return dest.length > 0 ?
                            <div className="row around-xs">
                              {dest.map((player, i) => 
                                <ErrorBroundray key={i}><CardFeaturedPro name={player.name} avaliationStar={player.total} mainJob={player.anuncios} photo={player.photo} link={player.id} /></ErrorBroundray>
                              )}
                            </div>
                            : null
                        } else {
                          // window.setTimeout(window.location.reload(), 500)
                          return (<p>Aconteceu algo de errado. Vamos tentar de novo.</p>)
                        }
                      }}
                    </Query>
                  </div>
                </div>
              </>
            }
          </div>
          <ErrorBroundray><Navbar /></ErrorBroundray>


        </div>
        <div className='col-xs-12' style={{ marginLeft: "-0.5rem", marginTop: "50px" }}>
          <Footer />
        </div>
      </Fragment>
    )
  }
};

//<li key={i} onClick={() => window.location.href = "/anuncios/" + hab.name.replace('/','+') }>{hab.name}</li>
